<template>
    <span>
        <a @click="helperModalVisible = true"><i class="fa fa-question-circle"></i></a>

        <portal to="modals" v-if="helperModalVisible">
            <modal @close="helperModalVisible = false">
                <template slot="header"><i class="fa fa-question-circle"></i> Info</template>
                <slot></slot>
            </modal>
        </portal>
    </span>
</template>

<script>
    export default {
        name: "InfoHelper",

        data:() => ({
            helperModalVisible: false,
        })
    }
</script>

<style scoped>

</style>
